module.exports = __webpack_public_path__ + "static/media/loc1_img31.5519dca3.jpg";